{
  "createFarmAddress_line_1": {
    "label": "Dirección Línea 1",
    "placeholder": "(Ingrese la dirección de la granja)"
  },
  "createFarmAddress_line_2": {
    "label": "Línea de dirección 2",
    "placeholder": null
  },
  "createFarmCity": {
    "label": "Ciudad",
    "placeholder": "(Ingresar ciudad)"
  },
  "createFarmCountry": {
    "label": "País",
    "placeholder": "(Seleccione país)"
  },
  "createFarmDescription": "De lo contrario, si eres el primer usuario de tu granja, puedes crear una cuenta de granja. Luego, puedes invitar a otros usuarios a unirse a tu granja.",
  "createFarmHelpTitle": "Acerca de las cuentas agrícolas",
  "createFarmLinkTo": "Nueva cuenta de granja",
  "createFarmName": {
    "label": "Nombre",
    "placeholder": "(Ingrese el nombre de la granja)"
  },
  "createFarmPostalCode": {
    "label": "Código Postal",
    "placeholder": "(Introduzca el código postal)"
  },
  "createFarmRegion": {
    "label": "Región",
    "placeholder": "(Seleccione región)"
  },
  "createFarmTitle": "Nueva cuenta de granja",
  "createNewFarmAccount": "Crear una nueva cuenta de granja",
  "enterFarmJoinCode": "Ingresar el código de ingreso a la granja",
  "enterYourFarmAddress": "Introduzca la dirección de su finca",
  "farmAccountHelpBodyText": "Su cuenta de granja es una representación de una granja real, que sirve como centro para todo lo siguiente:\n\nDispositivos: Sus dispositivos monitorean piezas de equipo de riego usando una variedad de sensores.\n\nCampos: Los campos brindan contexto a las actualizaciones de estado de los dispositivos y agregan datos de riego según la actividad dentro de sus límites.\n\nUsuarios: Permite que los gerentes y empleados de la granja interactúen con el sistema FarmHQ.\n\nSu(s) cuenta(s) de granja se diferencian de su cuenta de usuario en algunos aspectos importantes. No hay información de inicio de sesión que recordar; en cambio, cuando inicia sesión en farmhq.com con sus credenciales personales, los dispositivos y campos de su granja se cargarán automáticamente.\n\nP: ¿Puedo unirme a más de una cuenta de granja?\n\nR: Sí. Una vez que sea miembro de una granja, puede navegar hacia otra granja y unirse o crear otra.",
  "farmAccountHelpTitle": "Acerca de las cuentas agrícolas",
  "farmJoinCodeLabel": "Código de ingreso a la granja",
  "ifAnotherUserHasAlreadyCreatedYourFarmAccount": "Si alguien de su granja ya creó una cuenta, puede darle un código de ingreso a la granja. Puede usar ese código para vincular su cuenta de usuario a la cuenta de la granja.",
  "instructions": "A continuación, debes conectarte a una cuenta de granja.",
  "joinFarmAlreadyJoined": "Usted ya es miembro de esta cuenta de granja.",
  "joinFarmDescription": "Si alguien de su granja ya creó una cuenta, puede darle un código para unirse a la granja.\n\nConecte su cuenta de usuario a la cuenta de la granja ingresando el código a continuación:",
  "joinFarmLinkTo": "Únase a otra cuenta de granja",
  "joinFarmTitle": "Únete a Farm With Code",
  "joinFarmWithCode": "Únete a Farm With Code",
  "joinFarmWithCodeHelpBodyText": "Los códigos de ingreso a la granja permiten a los usuarios vincular su cuenta de usuario a una cuenta de granja. Al unirse a una cuenta de granja, los usuarios pueden ver y administrar todos los dispositivos asociados a esa granja.\n\nLos códigos de ingreso a la granja son códigos únicos de 6 caracteres que genera el propietario de la granja. Si usted es un usuario al que se le ha otorgado un código de ingreso a la granja, puede ingresarlo aquí para unirse a la cuenta de la granja.\n\nEl usuario que creó el código también debe decidir qué permiso tendrá en la cuenta de la granja. Esto determinará qué acciones puede realizar en la cuenta de la granja.",
  "joinFarmWithCodeHelpTitle": "Acerca de los códigos de ingreso a la granja",
  "newFarmAccount": "Nueva cuenta de granja",
  "noFarmsTitle": "Sin granjas",
  "successAddDevices": {
    "description": "Registre sus dispositivos FarmHQ",
    "text": "Agregar dispositivos"
  },
  "successDrawFields": {
    "description": "Dibuja los campos de tu granja",
    "text": "Dibujar campos"
  },
  "successInstructions": "A continuación se muestran algunas de las formas en las que puede comenzar a utilizar FarmHQ",
  "successTitle": "Éxito",
  "successViewSupport": {
    "description": "Explora nuestra documentación de soporte",
    "text": "Apoyo"
  },
  "userAccountCreatedMessage": "Cuenta de usuario creada",
  "welcomeToFarmHQ": "Bienvenido a FarmHQ",
  "whatWeUseFarmLocationForText": "Utilizamos esta información para asegurarnos de que nuestras funciones basadas en mapas funcionen correctamente. No compartimos esta información con terceros.",
  "whatWeUseFarmLocationForTitle": "Recopilación de direcciones de granjas"
}
